import { AxiosRequestConfig } from "axios";
import { CONSTANTS } from "common";

// const getSelectedLanguage = () => {
//     if (translation.length) {
//       return translation[0].localization;
//     }
//     return navigator.language.split("-")[0];
//   };

const jwtInterceptor = (config: AxiosRequestConfig<any>) => {
  config.withCredentials = true;

  if (config.headers) {
    const user = JSON.parse(localStorage.getItem(CONSTANTS.STORE_USER) || "null");
    if (user) {
      const { i18n } = user;
      config.headers["Accept-Language"] =
        i18n || navigator.language.split("-")[0];
    }

    if (!config.headers.Authorization) {
      const jwt = localStorage.getItem(CONSTANTS.STORE_JWT);
      if (jwt) {
        config.headers.Authorization = `Bearer ${jwt}`;
      }
    }
  }
  return config;
};
export default jwtInterceptor;
